import { Component, OnInit,Input } from '@angular/core';
import { CarrinhoItemsModel } from '../../../../models/carrinhoItems.model';

@Component({
    selector: 'monitor-produto',
    templateUrl: './monitor-produto.html',
    styleUrls: ['./monitor-produto.css']
})
export class MonitorProdutoComponent implements OnInit {
    @Input()
    pedido:any={}
    @Input()
    estados:any=[];
    constructor() { }

    ngOnInit(): void { }
    getPesoTotal(pedido){
        return CarrinhoItemsModel.getPesoTotal(pedido);
    }
    formatQtde(x){
        return CarrinhoItemsModel.formatQtde(x);
    }
}
